import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
import mainService from '../services/mainService';
import './ChangePassword.css';

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    Password: '',
    CPassword: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is logged in
    const storedUserData = localStorage.getItem('userData');
    if (!storedUserData) {
      navigate('/login');
      return;
    }

    try {
      const user = JSON.parse(storedUserData);
      setUserData(user);
    } catch (error) {
      console.error('Error parsing user data:', error);
      navigate('/login');
    }
  }, [navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear messages when user starts typing
    if (error) setError('');
    if (success) setSuccess('');
  };

  const validateForm = () => {
    if (!formData.Password.trim()) {
      setError('New Password is required');
      return false;
    }

    if (formData.Password.length < 6) {
      setError('Password must be at least 6 characters long');
      return false;
    }

    if (!formData.CPassword.trim()) {
      setError('Confirm Password is required');
      return false;
    }

    if (formData.Password !== formData.CPassword) {
      setError('Passwords do not match');
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // Prepare data for password change
      const passwordData = {
        CustomerId: userData.CustomerId || userData.Id,
        Password: formData.Password,
        CPassword: formData.CPassword
      };

      // Use registerCustomer function for password change
      const response = await mainService.registerCustomer(passwordData);
      
      if (response) {
        setSuccess('Password changed successfully!');
        setFormData({ Password: '', CPassword: '' });
        
        // Redirect to account page after 2 seconds
        setTimeout(() => {
          navigate('/account');
        }, 2000);
      } else {
        setError('Failed to change password. Please try again.');
      }
    } catch (error) {
      console.error('Error changing password:', error);
      setError('Failed to change password. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  if (!userData) {
    return (
      <div className="changepassword-page">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="changepassword-page">
      <div className="container">
        <div className="page-header">
          <h1 className="page-title">Change Password</h1>
        </div>

        <div className="changepassword-content">
          <div className="password-card">
            <div className="password-header">
              <div className="password-icon">
                <FaLock />
              </div>
              <h2>Update Your Password</h2>
              <p>Enter your new password below to update your account security.</p>
            </div>

            <form onSubmit={handleSubmit} className="password-form">
              {error && (
                <div className="error-message">
                  {error}
                </div>
              )}

              {success && (
                <div className="success-message">
                  {success}
                </div>
              )}

              <div className="form-group">
                <label htmlFor="Password" className="form-label">
                  New Password
                </label>
                <div className="password-input-container">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="Password"
                    name="Password"
                    value={formData.Password}
                    onChange={handleInputChange}
                    className="form-input"
                    placeholder="Enter new password"
                    required
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="CPassword" className="form-label">
                  Confirm Password
                </label>
                <div className="password-input-container">
                  <input
                    type={showConfirmPassword ? 'text' : 'password'}
                    id="CPassword"
                    name="CPassword"
                    value={formData.CPassword}
                    onChange={handleInputChange}
                    className="form-input"
                    placeholder="Confirm new password"
                    required
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>

              <div className="form-actions">
                <button
                  type="submit"
                  className="change-password-btn"
                  disabled={loading}
                >
                  {loading ? 'Changing Password...' : 'Change Password'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
